import { defineComponent, inferProps, useOnInput, type ReactiveComponent } from "vue-utils"
import type { GenericInputProps } from "./InputComponent"

type Props = GenericInputProps<string>

const StringInput: ReactiveComponent<Props> = (props) => {
	return () => <input type="text" value={props.value} onInput={useOnInput(props.setValue)} required />
}

export default defineComponent(StringInput, inferProps<Props>())
